import type { MorphemeHrefObject } from "@-/dev.improve.haniverse.lib.morpheme.href.entities";
import { MorphemePanelsContextProvider } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";
import { WordMorphemePanelsView } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.word";
import type { RefObject } from "react";
import type { MorphemeMnemonicsViewNavigationRefValue } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels";

/**
 * Renders a multi-character word directly (no info/mnemonics tab toggle, no toolbar, no star) —
 * words have only a info view. Shared by every route that hosts the morpheme panels
 * (`MorphemePanelsLayout` under every card route family, and the Learn review-card layout), so a word tapped from any of
 * them resolves to the word info view instead of dead-ending on `MorphemeNotFound`.
 *
 * `WordMorphemePanelsView` renders its own header + info tabs and reads only `morphemeHrefObject`
 * from `MorphemePanelsContext`. No `GraphemeMorphemePanelsContext` is published: a word has no
 * grapheme slices.
 */
export function MorphemePanelsWordView({
  character,
  morphemeHrefObject,
  noopSetActiveIndex,
  viewNavigationRef,
}: {
  character: string;
  morphemeHrefObject: MorphemeHrefObject;
  noopSetActiveIndex: () => void;
  viewNavigationRef: RefObject<MorphemeMnemonicsViewNavigationRefValue | null>;
}) {
  return (
    <MorphemePanelsContextProvider
      activeIndex={0}
      character={character}
      morphemeHrefObject={morphemeHrefObject}
      setActiveIndex={noopSetActiveIndex}
      viewNavigationRef={viewNavigationRef}
    >
      <WordMorphemePanelsView word={character} />
    </MorphemePanelsContextProvider>
  );
}
